import {Task} from './task.model';
import {Constants} from '../constants';

export class TaskType4 extends Task {
  morph: string = "";
  stem: string = "";
  morphedStem: string = "";
  affix: string = "";
  category: string = "";
  round1: {
    boxImage: { url: string; }
    sentenceBeforeWord: string;
    audioBeforeWord: { url: string; };
    sentenceAfterWord: string;
    audioAfterWord: { url: string; }
    mergeBefore: boolean;
    mergeAfter: boolean;
  };
  round2: {
    boxImage: { url: string; }
    sentenceBeforeWord: string;
    audioBeforeWord: { url: string; };
    sentenceAfterWord: string;
    audioAfterWord: { url: string; }
    mergeBefore: boolean;
    mergeAfter: boolean;
  };
  text1: {
    text: string;
    audio: { url: string; }
  };
  text2: {
    text: string;
    audio: { url: string; }
  };
  text3: {
    text: string;
    audio: { url: string; }
  };
  text4: {
    text: string;
    audio: { url: string; }
  };
  text5: {
    text: string;
    audio: { url: string; }
  };
  correctWord1: string;
  correctWord1Audio: { url: string; };
  correctWord2: string;
  correctWord2Audio: { url: string; };

  constructor(tasktype: number, input: Object) {
    super(tasktype, input);
    this.correctWord1Audio = { url: null };
    this.correctWord2Audio = { url: null };
    this.deserialize(input);
    if (Constants.useLocalAssets) {
      this.rewriteUrlsToLocalAssets(input);
    }
  }

  public playCompleteAudio(wordNumber, callback) {
    if (this['correctWord' + wordNumber + 'Audio'].url !== null) {
      let a = new Audio(this['correctWord' + wordNumber + 'Audio'].url);
      a.addEventListener('ended', () => {
        if (callback) {
          callback();
        }
      });
      a.play();
    } else {
      if (callback) {
        callback();
      }
    }
  }

/*  deserialize(instanceData: any) {
    // Note this.active will not be listed in keys since it's declared, but not defined
    const keys = Object.keys(this);

    for (const key of keys) {
      if (instanceData.hasOwnProperty(key)) {
        this[key] = instanceData[key];
      }
    }
  }*/

  deserialize(input: Object) {
    this.category = input['category'];
    this.morph = input['morph'];
    this.stem = input['stem'];
    this.morphedStem = input['morphedStem'];
    this.affix = input['affix'];
    this.round1 = input['round1'];
    this.round2 = input['round2'];
    this.text1 = input['text1'];
    this.text2 = input['text2'];
    this.text3 = input['text3'];
    this.text4 = input['text4'];
    this.text5 = input['text5'];
    this.correctWord1 = input['correctWord1'];
    this.correctWord2 = input['correctWord2'];
    if(input['correctWord1Audio']) {
      this.correctWord1Audio = input['correctWord1Audio'];
    }
    if(input['correctWord2Audio']) {
      this.correctWord2Audio = input['correctWord2Audio'];
    }

    return this;
  }

  rewriteUrlsToLocalAssets(input: Object) {
    if (this.round1) {
      if (this.round1.audioBeforeWord) {
        this.round1.audioBeforeWord.url =
          Constants.localAssetUrl + input['round1']['audioBeforeWord']['path'] + '/' + input['round1']['audioBeforeWord']['filename'];
      }
      if (this.round1.audioAfterWord) {
        this.round1.audioAfterWord.url =
          Constants.localAssetUrl + input['round1']['audioAfterWord']['path'] + '/' + input['round1']['audioAfterWord']['filename'];
      }
      if (this.round1.boxImage) {
        this.round1.boxImage.url =
          Constants.localAssetUrl + input['round1']['boxImage']['path'] + '/' + input['round1']['boxImage']['filename'];
      }
    }
    if (this.round2) {
      if (this.round2.audioBeforeWord) {
        this.round2.audioBeforeWord.url =
          Constants.localAssetUrl + input['round2']['audioBeforeWord']['path'] + '/' + input['round2']['audioBeforeWord']['filename'];
      }
      if (this.round2.audioAfterWord) {
        this.round2.audioAfterWord.url =
          Constants.localAssetUrl + input['round2']['audioAfterWord']['path'] + '/' + input['round2']['audioAfterWord']['filename'];
      }
      if (this.round2.boxImage) {
        this.round2.boxImage.url =
          Constants.localAssetUrl + input['round2']['boxImage']['path'] + '/' + input['round2']['boxImage']['filename'];
      }
    }
    if (this.text1 && this.text1.audio) {
        this.text1.audio.url =
          Constants.localAssetUrl + input['text1']['audio']['path'] + '/' + input['text1']['audio']['filename'];
    }
    if (this.text2 && this.text2.audio) {
      this.text2.audio.url =
        Constants.localAssetUrl + input['text2']['audio']['path'] + '/' + input['text2']['audio']['filename'];
    }
    if (this.text3 && this.text3.audio) {
      this.text3.audio.url =
        Constants.localAssetUrl + input['text3']['audio']['path'] + '/' + input['text3']['audio']['filename'];
    }
    if (this.text4 && this.text4.audio) {
      this.text4.audio.url =
        Constants.localAssetUrl + input['text4']['audio']['path'] + '/' + input['text4']['audio']['filename'];
    }
    if (this.text5 && this.text5.audio) {
      this.text5.audio.url =
        Constants.localAssetUrl + input['text5']['audio']['path'] + '/' + input['text5']['audio']['filename'];
    }
  }

}
